// custom typefaces
import 'typeface-montserrat';

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const currentPosition = getSavedScrollPosition(location);
  // const queriedPosition = getSavedScrollPosition({ pathname: `/random` });

  setTimeout(() => {
    window.scrollTo(...(currentPosition || [0, 0]));
  }, 1000);

  return false;
};
